export interface ProductStockFields {
  inStock?: boolean;
  stockQuantity?: number | null;
}

/** True when the product cannot be purchased (no stock). */
export function isProductOutOfStock(productOrQuantity?: ProductStockFields | number | null): boolean {
  if (typeof productOrQuantity === 'number' || productOrQuantity == null) {
    const stockQuantity = productOrQuantity;
    return stockQuantity == null || stockQuantity <= 0;
  }

  if (typeof productOrQuantity.inStock === 'boolean') {
    return !productOrQuantity.inStock;
  }

  const stockQuantity = productOrQuantity.stockQuantity;
  return stockQuantity == null || stockQuantity <= 0;
}
